<template>
  <div class="container-fluid">
 <div class="col-lg-12">
   <div class="row">
     <div class="category-head  d-flex" style="background-color: #ffffff">
       <div class="back-link col-lg-1 " style="color:black">
         <a @click="$router.back()">←</a>
       </div>
       <div class="search-friends col-lg-11">
         <input type="text"  :placeholder="$t('SEARCH_WITH_NAME_OR_EMAIL')" v-model="search"
                @keyup="searchFriend" style="height: 100%;width: 100%; ">
       </div>
     </div>
   </div>
 </div>



    <div class="row mt-3" v-if="! noFriendFound">
      <div class="col-lg-12" v-for="friend in findFriends" :key="friend.user_id">
        <div class="bcs-content d-flex justify-content-between align-items-center" @click="setRankingUser(friend)">
          <div class="d-flex align-items-center">
            <img :src="friend.image_url"
                 class="rounded-circle"
                 width="50" height="50"
                 :alt="friend.name"/>

            <div class="d-flex flex-column m-lg-3">
              <p class="pat-name">{{ friend.name }} <br> <span class="pat-level"> {{ $t('LEVEL') }} {{ friend.level }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-8" v-else>
      <div class="col-lg-12">
        <div class="d-flex justify-content-center align-items-center vh-100">
          <span class="nothing-found"> {{ $t('NOTHING_FOUND') }}  </span>
        </div>
      </div>
    </div>

    <RankingModal :modal-show="showModal"
                  :ranking-user="rankingUser"
                  v-if="showModal"/>
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import _ from "lodash";
import RankingModal from "@/views/components/RankingModal";

export default {
  name: "FindFriends",
  components: {
    RankingModal,
  },
  data() {
    return {
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      noFriendFound: true,
      search: '',
      friendList: [],
      timer: null,
      showModal: false,
      rankingUser: [],
    }
  },
  created() {
    this.emitter.on('modal-close-event', (evt) => {
      this.showModal = evt.eventContent;
      this.rankingUser = [];
    });
    this.emitter.on('update-user-event', (evt) => {
      this.updateUserData(evt.userId);
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    updateUserData(id) {
      this.friendList.forEach((element, index) => {
        if (element.user_id === id) {
          // eslint-disable-next-line vue/no-mutating-props
          this.friendList[index].friendship_status = 'requested';
        }
      });
    },
    setRankingUser(user_data) {
      this.rankingUser = user_data;
      this.showModal = true;
    },
    searchFriend() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        sendRequest('post', 'v2.0/friends/search', {search_string: this.search}, this.config)
            .then(response => {
              this.noFriendFound = true;
              if (response.success) {
                this.friendList = response.data.search_result;
                if (!_.isEmpty(this.friendList)) {
                  this.noFriendFound = false;
                }
              }
            })
            .catch(() => {
            });
      }, 800);
    }
  },
  computed: {
    findFriends() {
      return this.friendList;
    }
  }
}
</script>

<style scoped>

</style>
